import { createAction, props } from '@ngrx/store';
import { iCatalogos } from '../../entrada/entrada.interface';

export const cargaEmpresa = createAction('[Catalogos Component] cargaEmpresa', props<{ catEmpresa: any[] }>());
export const cargaModoEntrada = createAction('[Catalogos Component] cargaModoEntrada', props<{ catModoEntrada: any[] }>());
export const cargaTipo = createAction('[Catalogos Component] cargaTipo', props<{ catTipo: any[] }>());
export const cargaRemitente = createAction('[Catalogos Component] cargaRemitente', props<{ catRemitente: any[] }>());
export const cargaCatalogos = createAction('[Catalogos Component] cargaCatalogos', props<{ oCatalogos: iCatalogos }>());